import { render, staticRenderFns } from "./CardTicketIntercom.vue?vue&type=template&id=f2f6600c"
import script from "./CardTicketIntercom.vue?vue&type=script&lang=js"
export * from "./CardTicketIntercom.vue?vue&type=script&lang=js"
import style0 from "./CardTicketIntercom.vue?vue&type=style&index=0&id=f2f6600c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports